import React from 'react';
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { isCoverageAnalysis } from './analysisUtils';
import { nodeToText } from './textUtils';
import { markdownComponents } from './markdownComponents';
import { ExportPdfButton } from './components/ExportPdfButton';
import { CommentInEpicButton } from './components/CommentInEpicButton';
import { CapabilityImageButton } from './components/CapabilityImageButton';

// Custom wrapper passed to the markdown-renderer plugin so GFM tables render and
// coverage values are color-coded. `children` is the raw markdown string.
export const ChatMarkdown = ({ children }: { children: React.ReactNode }) => {
  const content = typeof children === 'string' ? children : nodeToText(children);
  const contentRef = React.useRef<HTMLDivElement>(null);
  const showExport = isCoverageAnalysis(content);
  return (
    <div style={{ whiteSpace: 'normal', textAlign: 'left', width: '100%' }}>
      <style>{`
        .rcb-md-table tbody tr:nth-child(even) { background-color: #fafafa; }
        .rcb-md-table tbody tr:hover { background-color: #fff8db; }
        .rcb-md-table th, .rcb-md-table td { overflow-wrap: anywhere; word-break: break-word; }
        .rcb-md-table th:nth-child(1), .rcb-md-table td:nth-child(1) { width: 18%; }
        .rcb-md-table th:nth-child(2), .rcb-md-table td:nth-child(2) { width: 19%; }
        .rcb-md-table th:nth-child(3), .rcb-md-table td:nth-child(3) { width: 17%; }
        .rcb-md-table th:nth-child(4), .rcb-md-table td:nth-child(4) { width: 9%; }
        .rcb-md-table th:nth-child(5), .rcb-md-table td:nth-child(5) { width: 19%; }
        .rcb-md-table th:nth-child(6), .rcb-md-table td:nth-child(6) { width: 18%; }
        .rcb-row-actions { opacity: 0.5; transition: opacity 0.15s ease; }
        .rcb-md-table tbody tr:hover .rcb-row-actions { opacity: 1; }
        .rcb-row-actions button { transition: transform 0.15s ease, box-shadow 0.15s ease; }
        .rcb-row-actions button:hover { transform: scale(1.15); box-shadow: 0 2px 6px rgba(0,0,0,0.2); }
      `}</style>
      <div ref={contentRef}>
        <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
          {content}
        </ReactMarkdown>
      </div>
      {showExport && (
        <div style={{ display: 'flex', gap: '8px', marginTop: '8px', marginLeft: '20px', flexWrap: 'wrap' }}>
          <ExportPdfButton contentRef={contentRef} />
          <CommentInEpicButton contentRef={contentRef} />
          <CapabilityImageButton analysisMd={content} />
        </div>
      )}
    </div>
  );
};
